import { render, staticRenderFns } from "./MerchantIds.vue?vue&type=template&id=78032b98&scoped=true&"
import script from "./MerchantIds.vue?vue&type=script&lang=ts&"
export * from "./MerchantIds.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantIds.vue?vue&type=style&index=0&id=78032b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78032b98",
  null
  
)

export default component.exports